import * as React from "react";
import {cx} from "emotion";

import "./share-result-modal.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";

import {ModalService3} from "../../../modal-service-3/modal-service-3";

export const ShareResultModal = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3<any>({
        width: 500,
        xdQaName: "Share Result Modal",
        next,
        rootNext,
    })],
    ["success", ({modal: {params: results}}, next) => next(!results.some((r) => !r.result.action))],
    ({modal: {params: results, close}, success}) => (
        <div className={cx("share-result-modal-31s", {success})}>
            <div className="header">
                <div
                    className="circle"
                    xd-qa-type="icon" xd-qa-name={"Share Result " + (success ? "Succeeded" : "Failed")}
                >
                    {success ? (
                        <i className="fa fa-thumbs-o-up"/>
                    ) : (
                        <i className="fa fa-warning"/>
                    )}
                </div>
            </div>
            <div className="content">
                <div className="platforms">
                    {results.map(({type, result: {action, data, page_info, error}}, i) => cs(
                        // keyed(page_info), // "hello",
                        keyed(i), // "hello",
                        () => (
                            <div className={cx("platform", {success: action})}>
                                <div className="icon" xd-qa-type="icon" xd-qa-name={"Icon " + i}>
                                    <div className="circle">
                                        {type === "twitter" ? (
                                            <img src="assets/x-icon-white.png"/>
                                        ) : (
                                            <i className={"fa fa-" + type}/>
                                        )}
                                    </div>
                                </div>
                                <div className="success-indicator" xd-qa-type="icon" xd-qa-name={action ? `${"Success " + i}` : `${"Failed " + i}`}>
                                    {action ? (
                                        <i className="fa fa-check"/>
                                    ) : (
                                        <i className="fa fa-close"/>
                                    )}
                                </div>
                                <div className="message">
                                    {action === "Scheduled" ? (
                                        <div className="description" xd-qa-type="text" xd-qa-name={action ? type + " Success Description" : type + " Failed Description"}>
                                            Your share was successfully scheduled!
                                        </div>
                                    ) : action ? (
                                        <div className="description" xd-qa-type="text" xd-qa-name={action ? type + " Success Description" : type + " Failed Description"}>
                                            Your share was successful!
                                        </div>
                                    ) : (() => {
                                        const flex = data || error;
                                        const i = flex.indexOf(".");
                                        const title = flex.substring(0, i);
                                        const desc = flex.substring(i+1).trim();
                                        return <>
                                            <div className="error" xd-qa-type="text" xd-qa-name="Error Title">
                                                {title}
                                            </div>
                                            <div className="description" xd-qa-type="text" xd-qa-name={action ? type + " Success Description" : type + " Failed Description"}>
                                                {desc}
                                            </div>
                                        </>;
                                    })()}
                                </div>
                            </div>
                        ),
                    ))}
                </div>

                {results.some(({result}) => result.action === "Scheduled") && (
                    <div className="disclaimer">
                        <div className="label">
                            Please note:
                        </div>
                        <div className="message" xd-qa-type="text" xd-qa-name="Message">
                            Scheduled posts may not be shared to your social media account(s) successfully if you{" "}
                            modify your account permissions or unlink your account before the scheduled date.
                        </div>
                    </div>
                )}
            </div>
            <div className="footer">
                <button {...{
                    onClick: close,

                    "xd-qa-type": "button",
                    "xd-qa-name": (
                        success ? (
                            "OK"
                        ) : (
                            "I understand"
                        )
                    ),
                }}>
                    {success ? (
                        "OK"
                    ) : (
                        "I understand"
                    )}
                </button>
            </div>
        </div>
    ),
);
